import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { InvitationTypes } from './utils';

import DivisionPrice from '../DivisionPrice';

import styles from './playerPendingInvitations.scss';

const Invitation = (props) => {
    const {
        invitation,
        onDeclineClick,
        hideDeclineButton,
        clubVerificationFee,
        event,
        addDivider,
    } = props;

    const isPreRegInvitation = invitation?.type === InvitationTypes.PRE_REGISTRATION;

    const invitedByText = useMemo(() => {
        if (invitation.type === InvitationTypes.ADMIN_ADD) {
            return `Added by ${invitation.inviteeName}`;
        }

        return `Invited by ${invitation.inviteeName}`;
    }, [invitation]);

    const onDeclineInvitationClick = () => {
        onDeclineClick(invitation);
    };

    if (isPreRegInvitation) {
        return (
            <>
                <div className={`${styles.invitation} d-flex aic mt8 mb8`}>
                    <div className="flex-1 mw0">
                        <div className={`${styles.invitationName} ellipsis`} data-testid={`modal.player-invitations.invitation-${invitation.id}.name`}>
                            {invitation.name}
                        </div>
                        <div className="mt8 ellipsis" data-testid={`modal.player-invitations.invitation-${invitation.id}.invited-by`}>
                            {invitedByText}
                        </div>
                    </div>
                    {!hideDeclineButton && (
                        <button
                            type="button"
                            className="btn btn-default btn-sm text-uppercase ml4"
                            onClick={onDeclineInvitationClick}
                            data-testid={`modal.player-invitations.invitation-${invitation.id}.decline-btn`}
                        >
                            Decline
                        </button>
                    )}
                </div>
                {addDivider && <div className="divider mt8 mb8" />}
            </>
        );
    }

    return (
        <>
            <div className={`${styles.invitation} mt8 mb8`}>
                <div className={`${styles.invitationName} ellipsis`} data-testid={`modal.player-invitations.invitation-${invitation.id}.name`}>
                    {invitation.name}
                </div>
                {hideDeclineButton && (
                    <div className={`${styles.invitationDetails} d-flex aic mt4`}>
                        <div className="flex-1 mw0 mr4">
                            <div className={`${styles.invitedBy} ellipsis`} data-testid={`modal.player-invitations.invitation-${invitation.id}.invited-by`}>
                                {invitedByText}
                            </div>
                            {invitation.shouldDisplayPartner && invitation.partnerName && (
                                <div className={`${styles.invitedBy} mt4 ellipsis`} data-testid={`modal.player-invitations.invitation-${invitation.id}.partner-name`}>
                                    {`Partner: ${invitation.partnerName}`}
                                </div>
                            )}
                        </div>
                        <DivisionPrice
                            division={invitation?.data}
                            utrTypeId={event.utrTypeId}
                            workflowVersion={event.workflowVersion}
                            allowOffPlatformPayments={event.allowOffPlatformPayments}
                            clubVerificationFee={clubVerificationFee}
                        />
                    </div>
                )}
                {!hideDeclineButton && (
                    <div className={`${styles.invitationDetails} d-flex ais mt4`}>
                        <div className="flex-1 mw0">
                            <div className={`${styles.invitedBy} mb4 ellipsis`} data-testid={`modal.player-invitations.invitation-${invitation.id}.invited-by`}>
                                {invitedByText}
                            </div>
                            {invitation.shouldDisplayPartner && invitation.partnerName && (
                                <div className={`${styles.invitedBy} mb4 ellipsis`} data-testid={`modal.player-invitations.invitation-${invitation.id}.partner-name`}>
                                    {`Partner: ${invitation.partnerName}`}
                                </div>
                            )}
                            <DivisionPrice
                                division={invitation?.data}
                                utrTypeId={event.utrTypeId}
                                workflowVersion={event.workflowVersion}
                                allowOffPlatformPayments={event.allowOffPlatformPayments}
                                clubVerificationFee={clubVerificationFee}
                            />
                        </div>
                        <button
                            type="button"
                            className={`btn btn-default btn-sm text-uppercase ml4 ${styles.invitationButton}`}
                            onClick={onDeclineInvitationClick}
                            data-testid={`modal.player-invitations.invitation-${invitation.id}.decline-btn`}
                        >
                            Decline
                        </button>
                    </div>
                )}
            </div>
            {addDivider && <div className="divider mt8 mb8" />}
        </>
    );
};

Invitation.propTypes = {
    invitation: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        type: PropTypes.number.isRequired,
        data: PropTypes.object.isRequired,
        inviteeName: PropTypes.string,
        inviteeId: PropTypes.string,
        shouldDisplayPartner: PropTypes.bool,
        partnerName: PropTypes.string,
        partnerId: PropTypes.string,
    }).isRequired,
    onDeclineClick: PropTypes.func,
    hideDeclineButton: PropTypes.bool,
    clubVerificationFee: PropTypes.number,
    event: PropTypes.shape({
        utrTypeId: PropTypes.string.isRequired,
        workflowVersion: PropTypes.number.isRequired,
        allowOffPlatformPayments: PropTypes.bool.isRequired,
    }).isRequired,
    addDivider: PropTypes.bool,
};

Invitation.defaultProps = {
    hideDeclineButton: false,
    onDeclineClick: () => { },
    clubVerificationFee: 0,
    addDivider: true,
};

export default Invitation;
